import styled from 'styled-components'

const InputError = styled.small`
  color: red;
`

export default InputError
